import { FC } from 'react';
import { Box, Row, Text } from '~/commonComponents';
import BulbIcon from '~/images/icons/BulbIcon';
import { Colors } from '~/themes/colors';

interface ITipBannerProps {
  visible: boolean;
}

export const TipBanner: FC<ITipBannerProps> = ({ visible }) => {
  return (
    <Box
      data-testid="tip-banner-wrapper"
      data-cy="tip-banner-wrapper"
      maxHeight={visible ? 60 : 0}
      opacity={visible ? 1 : 0}
      overflow="hidden"
      transition="max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-bottom 0.3s ease-in-out"
      marginBottom={visible ? 16 : 0}
    >
      <Row
        data-testid="tip-banner"
        data-cy="tip-banner"
        alignItems="center"
        gap={8}
        backgroundColor={Colors.primary_50}
        borderRadius={8}
        height={42}
        paddingHorizontal={16}
      >
        <BulbIcon color={Colors.secondary_500} />
        <Text>
          <Text bold fontSize={18} color="primary_500">
            Tip:{' '}
          </Text>
          <Text fontSize={16}>
            You can post for more than one day! Save time by creating multiple shifts at once.
          </Text>
        </Text>
      </Row>
    </Box>
  );
};
